import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CoreTranslationService } from '@core/services/translation.service';

import { ApplicationService } from 'app/services/models/application.service';
import { RoleService } from 'app/services/models/role.service';


import { locale as en, locale } from './i18n/en'
import { locale as fr } from './i18n/fr'
import { locale as de } from './i18n/de'
import { locale as pt } from './i18n/pt'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthorizationEndpointService } from 'app/services/models/authorization-endpoint.service';
import { GetRolesToEnpoint } from 'app/dtos/Role/role-endpoint-get';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'app/services/auth.service';

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RoleComponent implements OnInit {

  constructor(
    private roleService: RoleService,
    private applicationService: ApplicationService,
    private authorizationEndpointService: AuthorizationEndpointService,
    private _coreTranslationService: CoreTranslationService,
    private toastService: ToastrService,
    private modalService: NgbModal,
    public authService: AuthService
  ) {
    this._coreTranslationService.translate(en, fr, de, pt);
  }
  public getAllEndpoint = [];
  selectedRole: string = ''; // Seçili rol

  filteredEndpoints = {
    reading: [],
    writing: [],
    updating: [],
    deleting: []
  };

  async ngOnInit() {
    await this.getAllRoles();
    await this.getAuthorizeDefinitionEndoints();
  }

  async getAuthorizeDefinitionEndoints() {
    const authorizeDenifitionEndpoints = this.authService.isEndpointStatus('GET.Reading.GetAuthorizeDefinitionEndpoints');
    if (authorizeDenifitionEndpoints) {
      const data = await this.applicationService.GetAuthorizeDefinitionEndoints();
      const sortedDataList = data.sort(this.sortByActionLength);
      this.getAllEndpoint = sortedDataList;
      this.getAllEndpoint = this.getAllEndpoint.map(item => ({
        ...item,
        actions: item.actions.map(action => ({
          ...action,
          translatedDefinition: this.translate(item.name, action.definition)
        }))
      }));
      console.log(this.getAllEndpoint);
    }
  }

  filterActionsByType(actions: any[], filter: string): any[] {
    return actions.filter(action => action.actionType === filter);
  }

  sortByActionLength(a, b) {
    const lengthA = a.actions.length;
    const lengthB = b.actions.length;
    return lengthB - lengthA; // Büyükten küçüğe sırala
  }

  translate(name: string, definition: string): string {
    definition = definition?.replace(/\s+/g, '');
    return this.translateDefinition(name, definition);
  }

  translateDefinition(name, definition) {
    const localeData = locale.data.Definition;
    if (localeData[name] && localeData[name][definition]) {
      return localeData[name][definition];
    }
    console.log(definition);
    return definition;
  }

  data: any;
  menu;
  code;
  getRolesToEndpoint: any;
  selected: boolean = false;
  async addEvent(modalbasic, menu, code) {
    this.getRolesToEndpoint = await this.authorizationEndpointService.getRolesToEndpoint(menu, code);
    console.log(this.getRolesToEndpoint);
    this.menu = menu;
    this.code = code;
    this.prepareData();

    const modalRef = this.modalService.open(modalbasic);
    try {
      const result = await modalRef.result;
      if (result === 'Success') {
        const checkedItems = this.data.filter(action => action.checked).map(action => action.name);

        if (checkedItems != null) {
          await this.authorizationEndpointService.assignRoleToEndpoint(checkedItems, menu, code,
            () => this.toastService.success("Başarılı bir şekilde Role eklenmiştir"), () => this.toastService.info("Rol eklenirken bir sorun oluştu"));
        }
      }
    } catch (error) {

    }
  }

  onSelectItem(modal, selectedItem: any, name) {
    // Burada tıklanan item üzerine işlem yapılır
    if (selectedItem) {
      console.log(name);
      console.log(selectedItem);
      this.addEvent(modal, name, selectedItem.code);
    }
  }

  async prepareData() {
    // Tüm rolleri al
    await this.getAllRoles();

    if (this.getRolesToEndpoint && this.getRolesToEndpoint.length > 0) {
      // Her rol için checked değerini belirle
      this.data.forEach((role: GetRolesToEnpoint) => {
        role.checked = this.getRolesToEndpoint.includes(role.name);
      });
    } else {
      // getRolesToEndpoint null veya boşsa, tüm rollerin checked değerini false yap
      this.data.forEach((role: GetRolesToEnpoint) => {
        role.checked = false;
      });
    }
  }

  toggleCheckbox(action) {
    action.checked = !action.checked; // Checkbox durumunu değiştir
    console.log(this.getAllEndpoint);
  }

  async getAllRoles() {
    const response = await this.roleService.getAllRoles(0, 100, "");
    this.data = response.roles;
  }


  async onRoleChange() {
    if (this.selectedRole) {
      await this.getEndpointsForRole(this.selectedRole);  // Role seçildikten sonra endpoint'leri getir
    }
  }

  roleEndpoints: any[] = [];  // Seçilen role ait endpoint'ler
  async getEndpointsForRole(role: string) {
    const data = await this.authorizationEndpointService.getRoleToEnpoint(role);
    console.log(data);
    this.roleEndpoints = data;
    this.roleEndpoints = data;

    // Set the `checked` property based on the role's actions
    this.getAllEndpoint.forEach(endpoint => {
      endpoint.actions.forEach(action => {
        // If this action is in the role-specific endpoints, mark it as checked
        action.selected = this.isActionSelected(action);
      });
    });

    console.log(this.getAllEndpoint);
  }

  isActionSelected(action): boolean {
    return this.roleEndpoints.some(endpoint =>
      endpoint.code === action.code // Compare by 'code' only
    );
  }

  async saveSelections() {
    if (!this.selectedRole) {
      console.error('Lütfen bir rol seçin!');
      return;
    }

    let roleAssignments: any[] = [];

    this.getAllEndpoint.forEach(item => {
      let selectedActions = item.actions.filter(action => action.selected);

      if (selectedActions.length > 0) {
        roleAssignments.push({
          menu: item.name, // Menü ismi
          codes: selectedActions.map(action => action.code) // Seçilen kodlar
        });
      }
    });

    const requestBody = {
      role: this.selectedRole,
      menuAssignments: roleAssignments
    };
    console.log("Gönderilecek Veri:", requestBody);

    const data = await this.authorizationEndpointService.assignRoleToEndpoints(requestBody.role, requestBody.menuAssignments);
    if (data.status) {
      this.toastService.success(data.message);
    } else {
      this.toastService.error(data.message);
    }
  }
}